import { createAction } from 'redux-actions';
export const setSeatMapFilters = createAction('SET_SEATMAP_FILTERS');
export const setPassengerFilter = createAction('SET_PASSENGER_FILTER');
export const clearPassengerFilters = createAction('CLEAR_PASSENGER_FILTERS');
